module.exports = __webpack_public_path__ + "img/135.9.2ab5ffaa.png";